import { createRoot, Root } from 'react-dom/client';
import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { _getApolloClient, _resetApolloClient } from '../apollo/ApolloConfig';
import { BeaconProvider } from '../providers/BeaconProvider';
import { BrowserRouter as Router } from 'react-router-dom';
import { ErrorBoundaryWrapper } from '../components/containers/ErrorBoundaryWrapper';
import { GlobalErrorModalProvider } from '../providers/GlobalErrorModalProvider';
import { DevDebugProvider } from '../providers/DevDebugProvider';
import { ModalsProvider } from '../providers/ModalsProvider';
import { App } from '../modules/App';
import { AppProvider } from '../providers/AppProvider';

let root: Root;
export const _renderApp = () => {
  const selectedWorkspaceId = localStorage.getItem('selectedWorkspaceId') || '';
  const isLoggedIn = !!localStorage.getItem('token');
  root = createRoot(document.getElementById('root') as Element);
  root.render(
    <React.StrictMode>
      <ApolloProvider client={_getApolloClient()}>
        <Router>
          <ErrorBoundaryWrapper>
            <AppProvider selectedWorkspaceId={selectedWorkspaceId} isLoggedIn={isLoggedIn}>
              <BeaconProvider>
                <GlobalErrorModalProvider>
                  <DevDebugProvider>
                    <ModalsProvider>
                      <App />
                    </ModalsProvider>
                  </DevDebugProvider>
                </GlobalErrorModalProvider>
              </BeaconProvider>
            </AppProvider>
          </ErrorBoundaryWrapper>
        </Router>
      </ApolloProvider>
    </React.StrictMode>
  );
};

export const _resetApp = () => {
  setTimeout(() => {
    if (root) {
      root.unmount();
      _resetApolloClient().then(_renderApp);
    }
  }, 0);
};
